import { isValidCurrency } from "src/app/shared/pipes/indian-currency.pipe";

const DEFAULT_VALUE = '0';

export function roundOff(value: number | string): number | string {
    if (!(typeof value === 'number' || typeof value === 'string')) {
        return DEFAULT_VALUE;
    }
    if (!isValidCurrency(value.toString())) {
        return DEFAULT_VALUE;
    }
    value = `${Number(value).toFixed(2)}`;
    const parts = value.split('.');
    if (parts[1] && +parts[1] === 0) {
        return `${Number(value).toString().replace(/(\d)(?=(\d\d)+\d$)/g, '$1,')}`;
    } else {
        return `${Number(value).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')}`;
    }

}